import { URLSearchParamsInit } from 'react-router-dom';
import { Params } from 'ahooks/lib/useAntdTable/types';
import { SorterResult } from 'antd/lib/table/interface';
import { RawAxiosRequestHeaders } from 'axios';

import { apiGet } from 'api';

import { addQueryParamsToURL, getTableQueryParams } from 'utils';

import { ProductDashboardDto, ProductsDashboard } from 'codegen';

export const handleProductsTableChange = (
  headers: RawAxiosRequestHeaders,
  setSearchParams: (nextInit: URLSearchParamsInit) => void,
  setSortOrderInfo: (data: SorterResult<ProductDashboardDto>) => void,
) => async (
  params: Params[0],
) => {
  const tableQueryParams = getTableQueryParams(params, 'order');

  setSearchParams(tableQueryParams);

  if (params.sorter?.field) {
    setSortOrderInfo(params.sorter);
  }

  const url = addQueryParamsToURL('/products', tableQueryParams);

  const { data } = await apiGet<ProductsDashboard>({ url, headers });

  return {
    list: data.products,
    total: data.total,
  };
};
